import { Link } from "react-router";

import { Button } from "@/components/ui/button";

export function NotFoundPage() {
  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center px-4 text-center">
      <p className="text-muted text-[10px] font-medium tracking-[0.18em] uppercase">
        Johnson &amp; Johnson MedTech
      </p>
      <h1 className="font-display text-primary mt-2 text-6xl font-normal tracking-tight">404</h1>
      <p className="text-muted mt-3 text-lg">This page could not be found.</p>
      <Button asChild className="mt-8">
        <Link to="/home">Go home</Link>
      </Button>
    </div>
  );
}
